export const RankIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 16H6V8H2V16ZM8 16H12V2H8V16ZM14 16H18V10H14V16ZM0 18V6H6V0H14V8H20V18H0Z"
        fill="url(#paint0_linear_1297_6782)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1297_6782"
          x1="0"
          y1="0"
          x2="21.0706"
          y2="1.35529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3681C6" />
          <stop offset="1" stopColor="#2B4A9D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
